module.exports = __webpack_public_path__ + "static/media/itag_logo_new.2413ac03.png";